<template>
  <div>
    <div class="tab__header">
      <a href="#" class="tab__link p-2 block bg-primary-light no-underline flex justify-between" @click.prevent="active = !active">
        <strong>{{ title }}</strong>
        <font-awesome-icon v-if="active" :icon="['fas', 'caret-up']"/>
        <font-awesome-icon v-else :icon="['fas', 'caret-down']"/>
      </a>
    </div>
    <transition name="slide">
      <div v-show="active" class="tab__content px-2 my-2 text-sm">
        <slot/>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'AccordionElement',
  props: {
    title: {
      type: String,
      default: 'Titel',
    },
  },
  data: () => ({
    active: false,
  }),
};
</script>

<style lang="scss" scoped>
// Transition

.slide-enter-active {
  transition-duration: 0.3s;
  transition-timing-function: ease-in;
}

.slide-leave-active {
  transition-duration: 0.3s;
  transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
}

.slide-enter-to, .slide-leave {
  max-height: 150px;
  overflow: hidden;
}

.slide-enter, .slide-leave-to {
  overflow: hidden;
  max-height: 0;
}
</style>
